import { create } from 'zustand';

interface PlayInformationStoreState {
  like: number;
  setLike: (setter: number | ((prev: number) => number)) => void;
  bookmark: number;
  setBookmark: (setter: number | ((prev: number) => number)) => void;
}

const usePlayInformationStore = create<PlayInformationStoreState>((set) => ({
  like: 0,
  setLike: (setter) =>
    set((state) => ({
      like: typeof setter === 'function' ? setter(state.like) : setter,
    })),
  bookmark: 0,
  setBookmark: (setter) =>
    set((state) => ({
      bookmark: typeof setter === 'function' ? setter(state.bookmark) : setter,
    })),
}));

export default usePlayInformationStore;
